<!-- /首页  -->
<template>
  <div>
  <!-- <div style="padding: 10px;">
      <el-menu :default-active="activeIndex" class="el-menu-demo" mode="horizontal" @select="handleSelect">
        <el-menu-item :index="index.toString()" v-for="(item, index) in NavList">
          <div style="display: flex;">
            <p>{{ item.name }}</p>
            <div style="margin-left: 5px;">
              <i class="el-icon-more-outline" style="color: black;" @click="ModifyNavitem(item)"></i>
              <i class="el-icon-close" style="color: black;" @click="DeleteNavitem(item)"></i>
              <i class="el-icon-back" style="color: black;" @click="DeleteNavitem(item)" v-if="index != 0"></i>
              <i class="el-icon-right" style="color: black;" @click="DeleteNavitem(item)"
                v-if="index != NavList.length - 1"></i>
            </div>
          </div>
        </el-menu-item>
        <el-menu-item index="5"> <i class="el-icon-plus" style="color: black;"></i></el-menu-item>
      </el-menu>
            </div> -->
            
    <div  style="padding-left: 10px;">
      <p style="height: 40px;line-height: 40px;">导航栏配置：</p>
    </div>
    <div>
      <ConfigNav :disposeData="disposeData" style="padding: 20px" ConfigSource="CourseOrganization"></ConfigNav>
    </div>
    <div  style="border-top: 1px solid #ccc; padding-left: 10px;">
      <p style="height: 40px;line-height: 40px;">标签课程配置：</p>
    </div>
    <el-button style="margin-left: 10px;" type="primary" size="small" @click="AddNewLebel()">添加标题</el-button>
    <div style="height:410px; overflow-y: scroll;">
      <el-row v-for="(Sublevelitem, Sublevelindex)  in CourseSet">
        <el-col :span="4" style="padding: 10px;">
          <div style="display: flex;">
            <div style="line-height: 37px; width: 200px;">
              <p>{{ Sublevelitem.CourseInfo.name }}</p>
            </div>
            <div style="margin-left: 5px;line-height: 37px;">
              <el-button type="primary" size="small" @click="DeleteLebel(Sublevelitem.CourseInfo)">删除</el-button>
            </div>
            <div style="margin-left: 5px;line-height: 37px;">
              <el-button type="primary" size="small" @click="AddNewLebel(Sublevelitem.CourseInfo)">修改</el-button>
            </div>
          </div>
        </el-col>
        <el-col :span="24">
          <div style="padding-left: 10px;">
            <ul class="clearfix">
              <li class="curriculum" v-for="(item, index) in Sublevelitem.CourseConct" style="position: relative;"
                @click="Subleveldetails(Sublevelitem, item)">
                <div v-if="item.id == 21775" class="jingpinkechen">
                  <img
                    src="https://resource.rgzcloud.com/trainfile/pc_webreception%202.0/images/%E7%9C%81%E7%BA%A7%E7%B2%BE%E5%93%81.svg"
                    style="height: 28px;" alt="">
                </div>
                <!-- {{Sublevelitem.order_type}} -->
                <img :src="item.thumbnail" alt="">
                <p style="font-size: 16px; color:#000;margin-top: 10px;width:180px;font-weight: 540;" class="text_over">
                  {{ item.name }}
                </p>
                <p class="text_over" style="font-weight: 340;">
                  <span style="font-size: 14px; color: black;">{{ item.parent_name }}</span>
                  <span style="width: 5px; text-align: center;">| </span>
                  <span style="font-size: 14px; color: black;">{{ item.look_number
                  }}次学习</span>
                </p>
              </li>
              <li class="onekechenbox liststyle" @click="AddCourse(Sublevelitem.CourseInfo)">
                <img src="https://resource.rgzcloud.com/trainfile/pc_webreception%202.0/images/addkechengicon.png" alt=""
                  style="width: 40px; height: 40px; display: block; margin: 0 auto;">
              </li>
            </ul>
          </div>
        </el-col>
      </el-row>
    </div>
    <el-dialog :title="dialogtitle" :visible.sync="dialogVisible" width="25%">
      <div style="display: flex;">
        <p style="line-height: 30px;">名称：</p>
        <div>
          <el-input v-model="currentnav.name" placeholder="请输入名称"></el-input>
        </div>
      </div>
      <div style="display: flex;margin-top: 10px;">
        <p style="line-height: 30px;">链接：</p>
        <div>
          <el-input v-model="currentnav.link" placeholder="请输入链接"></el-input>
        </div>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="AddNavList_FN">确 定</el-button>
      </span>
    </el-dialog>
    <el-dialog :title="dialogLebel" :visible.sync="dialogVisibleLebel" width="25%">
      <div style="display: flex;">
        <p style="line-height: 30px;">名称：</p>
        <div>
          <el-input v-model.trim="LebelText" placeholder="请输入名称"></el-input>
        </div>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisibleLebel = false">取 消</el-button>
        <el-button type="primary" @click="AddLebel_FN">确 定</el-button>
      </span>
    </el-dialog>
    <div>
      <el-dialog title="请选择课程" :close-on-click-modal="false" :close-on-press-escape="false" :visible.sync="dialogVisibleSee" width="60%" :before-close="GetCourse_bind_List">
        <!-- {{config_item}} -->
        <seeConfigMajorList v-if="dialogVisibleSee" :disposeData="disposeData" :config_item="config_item">
        </seeConfigMajorList>
      </el-dialog>
    </div>
  </div>
</template>

<script>
import {
  config_organization_course_get_list
} from "../../../assets/js/network/network";
import ConfigNav from "./ConfigNav";
import seeConfigMajorList from "./ConfigCourse7"
export default {
  name: "Dispose7",
  components: {
    ConfigNav,
    seeConfigMajorList
  },
  props: [],
  data() {
    return {
      activeIndex: '0',
      LebelText: '',
      dialogLebel: '添加标题',
      dialogVisibleLebel: false,
      dialogVisibleSee: false,
      dialogtitle: '添加导航',
      dialogVisible: false,
      CurrentLebel: null,
      config_item: '',
      disposeData:{
				is_default: JSON.parse(localStorage.getItem('session')).organization_rtype,
				organization_id:JSON.parse(localStorage.getItem('session')).id,
			},
      currentnav: {
        name: '',
        link: ''
      },
      NavList: [
        {
          name: '首页',
          link: '/'
        },
        {
          name: '仿真数字云',
          link: '/'
        },
        {
          name: '资源中心',
          link: '/'
        },
        {
          name: '教学管理',
          link: '/'
        }
      ],
      CourseSet: [
        {
          CourseInfo: {
            name: '精品课程',
            id: 123
          },
          CourseConct: [{
            "auto_id": 68,
            "config_id": 10,
            "label_id": 22,
            "sort": 1,
            "id": 10016,
            "label_name": null,
            "name": "建筑构造",
            "introduce": "房屋建筑构造仿真实训系统以“十三五”课程教材为依托，结合虚拟仿真技术，将课程内抽象的文字信息以三维立体的模型展现；以空间性的真实视觉冲击，配以虚拟的放大缩小，观看各类构件的整体、细部构造；同时配以讲解细致的4D微课，达到快捷、高效、高质量的教学目的。最终解决技能型人才培养过程中基本功底不扎实、周期长、成本高的教学难题，为培养社会技能型人才奠定坚实的基石。",
            "banner": "http:\/\/sourcelib.oss-cn-qingdao.aliyuncs.com\/upload\/b65f014ef70c7347d95337b77e5a254d.jpg",
            "thumbnail": "http:\/\/sourcelib.oss-cn-qingdao.aliyuncs.com\/upload\/8d31698e93f47791e1eb30e21dd9614a.jpg",
            "parent_id": 10001,
            "level": 2,
            "node_id": 567347999932416,
            "node_id_min": 567347999932415,
            "node_id_max": 571746046443520,
            "look_number": 135938
          }]
        }
      ]
      ,

    };
  },
  mounted() {
    this.GetCourseList();


  },
  methods: {
    GetCourse_bind_List() {
      let data = {
        organization_id: this.disposeData.organization_id,
      };
      this.dialogVisibleSee = false
      config_organization_course_get_list(data).then((res) => {
        if (res.code == 0) {
          this.CourseSet.forEach((item1, inex1) => {
            item1.CourseConct = []
          })
          this.dataList = res.ret;
          this.dataList.map((item, index) => {
            this.CourseSet.forEach((item1, inex1) => {
              if (item.is_bind == 1 && item.config_id==item1.CourseInfo.id) {
                item1.CourseConct.push(item)
              }
            })
          });
         
        }
      });
    },
    AddCourse(item) {
        this.dialogVisibleSee = true; 
      this.config_item = item
    },
    GetCourseList() {
      this.$get(this.$api.config_organization_course_list, {
        organization_id: this.disposeData.organization_id,
      }).then(res => {
        this.CourseSet = []
        res.ret.forEach((item, index) => {
          this.CourseSet.push({
            CourseInfo: item,
            CourseConct: []
          })
        });
        this.GetCourse_bind_List()
      })
    },
    AddLebel_FN() {
      if (!this.LebelText) {
        this.$message.error('请填写标题名称');
        return
      }
      let data = {
        organization_id: this.disposeData.organization_id,
        is_default: this.disposeData.is_default,
        name: this.LebelText,
        type: 1,
      }
      console.log(this.CurrentLebel)
      if (this.CurrentLebel != null) {
        data.id = this.CurrentLebel.id,
          data.type = 2;
      }
      this.$post(this.$api.config_organization_course_add_edit, data).then(res => {

        if (res.code == 0) {

          this.dialogVisibleLebel = false;
          this.GetCourseList();
        }
      })
    },
    AddNewLebel(item = null) {
      if (item) {
        this.dialogLebel = '修改标题'
        this.dialogVisibleLebel = true;
        this.LebelText = item.name;
        this.CurrentLebel = item;
      } else {
        this.dialogLebel = '添加标题'
        this.dialogVisibleLebel = true;
        this.CurrentLebel = null
        this.LebelText = '';
      }

    },
    DeleteLebel(item) {
      this.$confirm('是否删除此标签', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.$post(this.$api.config_organization_course_delete, {
          id: item.id
        }).then(res => {
          if (res.code == 0) {
            this.$message({
              type: 'success',
              message: '删除成功!'
            });
            this.GetCourseList();
          }
        })

      }).catch(() => {
        this.$message({
          type: 'info',
          message: '已取消删除'
        });
      });
    },
    DeleteNavitem(item) {
      this.$confirm('是否删除此导航', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.$message({
          type: 'success',
          message: '删除成功!'
        });
      }).catch(() => {
        this.$message({
          type: 'info',
          message: '已取消删除'
        });
      });
    },
    ModifyNavitem(item) {
      this.dialogVisible = true
      this.dialogtitle = '修改导航';
      this.currentnav = item;
    },
    AddNavList_FN() {

    },
    handleSelect(index) {
      if (index == 5) {
        this.dialogVisible = true
        this.dialogtitle = '添加导航'
      }
    }
  },
};
</script>

<style scoped>
.titlestyle {
  font-family: PingFang SC;
  font-weight: bold;
  font-size: 18px;
}

.onekechenbox {
  width: calc(14.4% - 20px);
  height: 80px;
  border: 1px solid #C5C5C5;
  background: #F3F3F3;
  opacity: 1;
  padding-top: 40px;
  border-radius: 12px;
  float: left;
  cursor: pointer;
}

.curriculum {
  margin-right: 19px;
  float: left;
  cursor: pointer;
  margin-bottom: 20px;
  width: calc(14.45% - 19px);
}

.curriculumtops:hover>p {
  color: #7A89ED !important;
}

.curriculumtops {
  line-height: 30px;
  margin-bottom: 0px !important;
}

.curriculum:nth-child(7n) {
  margin-right: 0;
}

.curriculum p {
  margin-bottom: 0px;
  font-size: 12px;
  color: #919191;
}

.curriculum>img {
  width: 100%;
  height: 124px;
  background: rgba(255, 255, 255, 0.39);
  opacity: 1;
  border-radius: 12px;
}
</style>
